var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonthlyPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9774 10.3107L24.5783 5.91156C23.995 5.32823 23.2032 5 22.3788 5H11.2223C9.50343 5 8.11121 6.39223 8.11121 8.11111V29.8889C8.11121 31.6078 9.50343 33 11.2223 33H26.7779C28.4968 33 29.889 31.6078 29.889 29.8889V12.5102C29.889 11.6858 29.5608 10.894 28.9774 10.3107V10.3107Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.889 12.7778H23.6668C22.8081 12.7778 22.1112 12.0809 22.1112 11.2222V5",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4178 26.0778H21.5823",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1848 20.1682V18.3513C17.1848 17.8505 17.5908 17.4445 18.0917 17.4445H19.9086C20.4095 17.4445 20.8155 17.8505 20.8155 18.3513V20.1682C20.8155 20.6691 20.4095 21.0751 19.9086 21.0751H18.0917C17.5908 21.0736 17.1848 20.6676 17.1848 20.1682Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7778 27.4264V25.6096C12.7778 25.1087 13.1838 24.7027 13.6847 24.7027H15.5016C16.0025 24.7027 16.4085 25.1087 16.4085 25.6096V27.4264C16.4085 27.9273 16.0025 28.3333 15.5016 28.3333H13.6847C13.1838 28.3333 12.7778 27.9273 12.7778 27.4264Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5933 27.4264V25.6096C21.5933 25.1087 21.9993 24.7027 22.5002 24.7027H24.317C24.8179 24.7027 25.2239 25.1087 25.2239 25.6096V27.4264C25.2224 27.9273 24.8164 28.3333 24.3155 28.3333H22.4986C21.9993 28.3333 21.5933 27.9273 21.5933 27.4264H21.5933Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4845 24.7089L20.1356 21.0378",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5156 24.7089L17.8645 21.0378",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyPdf);
export default __webpack_public_path__ + "static/media/monthly-pdf.b31ca489cbc810befe991222d9f1d427.svg";
export { ForwardRef as ReactComponent };